export const DEFAULT_SPORT = "mlb";
export const SPORT_STORAGE_KEY = "statsfan.activeSport";

export const SPORTS = [
  { id: "mlb", label: "MLB", name: "Baseball", accent: "#84E6E5" },
  { id: "nba", label: "NBA", name: "Basketball", accent: "#F97316" },
  { id: "nfl", label: "NFL", name: "Football", accent: "#A3E635" },
];

export const SPORT_IDS = SPORTS.map((sport) => sport.id);

export const SPORT_BY_ID = Object.fromEntries(
  SPORTS.map((sport) => [sport.id, sport])
);

export const SPORT_BASE_PATH = {
  mlb: "/app",
  nba: "/app/nba",
  nfl: "/app/nfl",
};

export const DESTINATION_PATHS = {
  home: "",
  compare: "/compare",
  players: "/players",
  teams: "/teams",
  queryBuilder: "/queryBuilder",
  trivia: "/trivia",
  community: "/community",
  allTimeGreats: "/all-time-greats",
  lineup: "/lineup",
};

export const DESTINATION_LABELS = {
  home: "Home",
  compare: "Compare Players",
  players: "Players",
  teams: "Teams",
  queryBuilder: "Stat Explorer",
  trivia: "Trivia",
  community: "Community",
  allTimeGreats: "All-Time Greats",
  lineup: "My Lineup",
  player: "Player",
  team: "Team",
  game: "Game",
  dashboard: "Dashboard",
  profile: "Profile",
  settings: "Settings",
  admin: "Admin",
};

export const SWITCH_ALIASES = {
  player: "players",
  team: "teams",
  game: "home",
};

export const ACCOUNT_DESTINATIONS = {
  dashboard: "/app/dashboard",
  profile: "/app/profile",
  settings: "/app/settings",
  admin: "/app/admin",
};

export const LIVE_DESTINATIONS = {
  mlb: [
    "home",
    "compare",
    "players",
    "teams",
    "queryBuilder",
    "trivia",
    "community",
    "allTimeGreats",
    "lineup",
  ],
  nba: [
    "home",
    "compare",
    "players",
    "teams",
    "queryBuilder",
    "trivia",
    "community",
    "allTimeGreats",
    "lineup",
  ],
  nfl: [
    "home",
    "compare",
    "players",
    "teams",
    "queryBuilder",
    "trivia",
    "community",
    "allTimeGreats",
    "lineup",
  ],
};

export const NAV_GROUPS = [
  {
    id: "explore",
    label: "Explore",
    destinations: ["home", "compare", "players", "teams", "queryBuilder"],
  },
  {
    id: "play",
    label: "Play & Learn",
    destinations: ["trivia", "community", "allTimeGreats"],
  },
  {
    id: "account",
    label: "My Stuff",
    destinations: ["dashboard", "lineup", "profile"],
  },
];
